export const version = "abstract-signer/5.2.0";
